import React from "react";
import { verifyOTP } from "../../utils/util-functions/verifyOTP";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import userLogin from "../../utils/userLogin";

const SignInButton = ({ otp, hashedResponse, tnc, mobileNo }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  function handleSignIn() {
    if (otp.length === 6 && tnc) {
      if (verifyOTP(otp, hashedResponse)) {
        const api = `${process.env.REACT_APP_RANK_PLUS_USER_LOGIN}mobile=${mobileNo}`;
        userLogin(api, navigate, dispatch);
      } else {
        toast("incorrect OTP");
      }
    }
    if (!tnc) {
      toast("Click on tnc");
    }
    if (otp.length < 6) {
      toast("otp is less than 6 digits");
    }
  }

  return (
    <div className="flex items-center justify-center my-7">
      <button
        className="px-5 py-3 text-l font-bold text-white bg-gradient-to-r from-cyan-400 to-purple-600 rounded-full shadow-lg hover:-translate-y-1 hover:shadow-2xl transition-all lg:w-[27rem] w-[20rem]"
        onClick={handleSignIn}
      >
        <span className="drop-shadow-md">Sign In</span>
      </button>
    </div>
  );
};

export default SignInButton;
